var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo, useCallback, useMemo } from 'react';
import theme from '../../../../theme';
import { useField, useFormikContext } from 'formik';
import ReactPhoneInput from '@traum-ferienwohnungen/react-phone-input-2';
import FormInput from '../form-input';
import { useFormField } from '../../hooks';
import { useErrorTrackingOnSubmit, useHandleBlur } from '../hooks';
import '@traum-ferienwohnungen/react-phone-input-2/lib/high-res.css';
var _getStyles = function (fontFamily, fontSize, lineHeight, borderRadius, fontColor) { return ({
    containerStyle: {
        width: '100%',
    },
    inputStyle: __assign({ width: '100%', height: 'unset', lineHeight: lineHeight || '1.15rem', color: fontColor || '#212121', borderColor: theme.colors.tfwDefaultInputBorder, borderRadius: borderRadius || theme.typography.border.radius.small, padding: theme.spacing.small + " " + theme.spacing.small + " " + theme.spacing.small + " 60px", fontFamily: fontFamily || theme.typography.font.family.lato }, (fontSize ? { fontSize: fontSize } : {})),
    buttonStyle: {
        backgroundColor: 'transparent',
        borderRadius: (borderRadius || theme.typography.border.radius.small) + " 0 0 " + (borderRadius || theme.typography.border.radius.small),
        color: fontColor || '#212121',
        borderColor: theme.colors.tfwDefaultInputBorder,
        borderStyle: 'solid',
        borderWidth: theme.typography.border.width.xxxThin + " 0 " + theme.typography.border.width.xxxThin + " " + theme.typography.border.width.xxxThin,
    },
}); };
var PhoneInput = function (_a) {
    var label = _a.label, subtext = _a.subtext, tooltip = _a.tooltip, _b = _a.placeholder, placeholder = _b === void 0 ? '' : _b, fontFamily = _a.fontFamily, fontSize = _a.fontSize, lineHeight = _a.lineHeight, borderRadius = _a.borderRadius, fontColor = _a.fontColor, countryCode = _a.countryCode, trackValidationOnBlur = _a.trackValidationOnBlur, trackValidationOnSubmit = _a.trackValidationOnSubmit, restProps = __rest(_a, ["label", "subtext", "tooltip", "placeholder", "fontFamily", "fontSize", "lineHeight", "borderRadius", "fontColor", "countryCode", "trackValidationOnBlur", "trackValidationOnSubmit"]);
    var _c = useFormikContext(), setFieldValue = _c.setFieldValue, validateOnBlur = _c.validateOnBlur;
    var field = useField(restProps)[0];
    var styles = useMemo(function () { return _getStyles(fontFamily, fontSize, lineHeight, borderRadius, fontColor); }, [fontFamily, fontSize, lineHeight, borderRadius, fontColor]);
    var _d = useFormField(field.name), error = _d.error, customError = _d.customError, customWarning = _d.customWarning, touched = _d.touched, validateField = _d.validateField;
    var onBlur = field.onBlur, value = field.value, restField = __rest(field, ["onBlur", "value"]);
    var name = field.name;
    var setValue = useCallback(function (value, shouldValidate) { return setFieldValue(name, value, shouldValidate); }, [name, setFieldValue]);
    var _handleChange = useCallback(function (value) { return setValue(value, false); }, [setValue]);
    var _handleBlur = useHandleBlur(onBlur, name, validateField, validateOnBlur, trackValidationOnBlur);
    useErrorTrackingOnSubmit(name, trackValidationOnSubmit);
    return (React.createElement(FormInput, { label: label, subtext: subtext, tooltip: tooltip, name: name, error: error || customError, warning: customWarning, touched: touched },
        React.createElement(ReactPhoneInput, { autoFormat: false, inputProps: restField, onChange: _handleChange, value: value, onBlur: _handleBlur, placeholder: placeholder, country: countryCode, containerStyle: styles.containerStyle, inputStyle: styles.inputStyle, buttonStyle: styles.buttonStyle })));
};
export default memo(PhoneInput);
